import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/layouts/account.vue")),
  blank: defineAsyncComponent(() => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/layouts/blank.vue")),
  default: defineAsyncComponent(() => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/layouts/default.vue")),
  search: defineAsyncComponent(() => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/layouts/search.vue"))
}